import { motion } from "framer-motion";
import { assets } from "@/config/site";
import { EASE } from "./Reveal";

const LETTERS = "REVAUTOZ".split("");

export const Loader = () => (
    <motion.div
        data-testid="brand-loader"
        className="fixed inset-0 z-[100] flex items-center justify-center bg-rz-black"
        exit={{ opacity: 0 }}
        transition={{ duration: 0.9, ease: EASE }}
    >
        <div className="flex items-center gap-4 sm:gap-5">
            <motion.img
                src={assets.emblemTransparent}
                alt=""
                aria-hidden="true"
                className="h-14 w-14 object-contain sm:h-16 sm:w-16"
                initial={{ opacity: 0, scale: 0.4 }}
                animate={{ opacity: 1, scale: [0.4, 1.06, 1] }}
                transition={{ duration: 0.55, times: [0, 0.7, 1], ease: EASE }}
            />
            <span
                aria-label="Revautoz"
                className="flex items-center font-display text-3xl font-bold tracking-[0.22em] text-rz-white sm:text-4xl"
            >
                {LETTERS.map((l, i) => (
                    <motion.span
                        key={i}
                        aria-hidden="true"
                        className="inline-block"
                        initial={{ opacity: 0, y: 6 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.65 + i * 0.08, duration: 0.12, ease: "easeOut" }}
                    >
                        {l}
                    </motion.span>
                ))}
                <motion.span
                    aria-hidden="true"
                    className="ml-1 inline-block h-[0.95em] w-[3px] bg-rz-red"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: [0, 1, 1, 0] }}
                    transition={{ delay: 0.6, duration: 1.5, times: [0, 0.1, 0.85, 1] }}
                />
            </span>
        </div>
        <motion.div
            className="absolute bottom-16 h-px bg-rz-red"
            initial={{ width: 0, opacity: 1 }}
            animate={{ width: 96, opacity: [1, 1, 0] }}
            transition={{ duration: 2, times: [0, 0.65, 1], ease: EASE }}
        />
    </motion.div>
);
